<template>
  <div class="bg-page-container">
    <!-- 页面头部 -->
    <div class="bg-page-header">
      <div class="header-title">
        <i class="el-icon-s-check"></i>
        <span>学校资料审核</span>
      </div>
    </div>

    <!-- 状态筛选 -->
    <div class="bg-toolbar">
      <div class="toolbar-left">
        <el-radio-group v-model="status" size="small" @change="radioChange">
          <el-radio-button label="待审核">
            <i class="el-icon-time"></i> 待审核
          </el-radio-button>
          <el-radio-button label="已审核">
            <i class="el-icon-check"></i> 已审核
          </el-radio-button>
          <el-radio-button label="未上传">
            <i class="el-icon-upload"></i> 未上传
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="toolbar-right">
        <el-tag type="info" size="small">共 {{ totalCount }} 条记录</el-tag>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="bg-table-section">
      <el-table
        :data="materials"
        v-loading="loading"
        :height="tableHeight"
        class="bg-table"
        stripe>
        <el-table-column prop="schoolName" label="学校" min-width="180" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="userName" label="用户" min-width="120" align="center">
        </el-table-column>
        <el-table-column label="资料" width="120" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.fileUrl && scope.row.fileUrl !== ''" class="image-preview-cell">
              <el-image
                :src="scope.row.fileUrl"
                :preview-src-list="[scope.row.fileUrl]"
                fit="cover"
                class="thumbnail-image">
                <div slot="error" class="image-error">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <span v-else class="no-image">无资料</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="getStatusType(scope.row.status)"
              size="small"
              effect="light">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === '待审核'"
              type="success"
              size="mini"
              icon="el-icon-check"
              @click="handleAuth(scope.row)">
              通过
            </el-button>
            <el-button
              v-else
              type="info"
              size="mini"
              disabled>
              {{ scope.row.status === '已审核' ? '已通过' : '待上传' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="bg-pagination"
        background
        :page-size="pageSize"
        :current-page="pageIndex"
        @current-change="currentChange"
        :total="totalCount"
        :page-sizes="[15, 30, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>

    <!-- 空状态 -->
    <bg-empty
      v-if="!loading && materials.length === 0"
      :icon="getEmptyIcon()"
      :description="getEmptyText()"
      :hint="getEmptyHint()">
    </bg-empty>

    <!-- 图片预览对话框 -->
    <el-dialog
      title="资料预览"
      :visible.sync="previewVisible"
      width="600px"
      class="bg-dialog preview-dialog"
      center>
      <div class="preview-container">
        <el-image
          :src="previewUrl"
          fit="contain"
          class="preview-image">
          <div slot="error" class="preview-error">
            <i class="el-icon-picture-outline"></i>
            <p>图片加载失败</p>
          </div>
        </el-image>
      </div>
      <div v-if="previewData" class="preview-info">
        <p><strong>学校：</strong>{{ previewData.schoolName }}</p>
        <p><strong>用户：</strong>{{ previewData.userName }}</p>
        <p><strong>状态：</strong>
          <el-tag :type="getStatusType(previewData.status)" size="small">
            {{ previewData.status }}
          </el-tag>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="previewVisible = false">关闭</el-button>
        <el-button
          v-if="previewData && previewData.status === '待审核'"
          type="success"
          @click="authFromPreview">
          审核通过
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/utils/api'
import BgEmpty from '@/components/common/BgEmpty'

export default {
  name: 'SchoolReview',
  components: {
    BgEmpty
  },
  data () {
    return {
      loading: false,
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      tableHeight: 0,
      materials: [],
      status: '待审核',
      previewVisible: false,
      previewUrl: '',
      previewData: null
    }
  },
  created () {
    this.tableHeight = (window.innerHeight - 240)
    this.query()
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    currentChange (current) {
      this.pageIndex = current
      this.query()
    },
    query () {
      this.loading = true
      this.$axios.post(api.getSchoolReviewMaterials, {
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
        Status: this.status
      })
        .then(res => {
          this.materials = res.data.result.items
          this.totalCount = res.data.result.totalCount
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleAuth (row) {
      this.$confirm('确定要通过该学校的资料审核吗？', '审核确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.auth(row.id)
      })
    },
    auth (id) {
      this.loading = true
      this.$axios.get(api.getSchoolAuthority(id))
        .then(() => {
          this.$message.success('审核通过')
          this.previewVisible = false
          this.query()
        })
        .catch(() => {
          this.loading = false
        })
    },
    authFromPreview () {
      if (this.previewData) {
        this.auth(this.previewData.id)
      }
    },
    radioChange () {
      this.pageIndex = 1
      this.query()
    },
    getStatusType (status) {
      const typeMap = {
        '待审核': 'warning',
        '已审核': 'success',
        '未上传': 'info'
      }
      return typeMap[status] || 'info'
    },
    getEmptyIcon () {
      const iconMap = {
        '待审核': 'el-icon-time',
        '已审核': 'el-icon-check',
        '未上传': 'el-icon-upload'
      }
      return iconMap[this.status] || 'el-icon-s-check'
    },
    getEmptyText () {
      const textMap = {
        '待审核': '暂无待审核资料',
        '已审核': '暂无已审核资料',
        '未上传': '暂无未上传资料'
      }
      return textMap[this.status] || '暂无数据'
    },
    getEmptyHint () {
      const hintMap = {
        '待审核': '所有资料已审核完成',
        '已审核': '暂无已审核的记录',
        '未上传': '所有学校已上传资料'
      }
      return hintMap[this.status] || '请切换状态查看其他数据'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.bg-page-container {
  @include page-container;
}

.bg-page-header {
  @include flex-between;
  margin-bottom: $spacing-lg;
  padding: $spacing-md $spacing-lg;
  background: var(--bg-white);
  border-radius: $border-radius-base;
  box-shadow: var(--shadow-base);

  .header-title {
    display: flex;
    align-items: center;
    gap: $spacing-sm;
    font-size: $font-size-lg;
    font-weight: 600;
    color: var(--text-primary);

    i {
      font-size: $font-size-xl;
      color: $primary-color;
    }
  }
}

.bg-toolbar {
  @include flex-between;
  margin-bottom: $spacing-lg;
  padding: $spacing-md $spacing-lg;
  background: var(--bg-white);
  border-radius: $border-radius-base;
  box-shadow: var(--shadow-base);

  .toolbar-left {
    .el-radio-group {
      .el-radio-button__inner {
        display: flex;
        align-items: center;
        gap: 4px;
      }
    }
  }

  .toolbar-right {
    display: flex;
    align-items: center;
  }
}

.bg-table-section {
  @include table-section;

  .bg-table {
    border-radius: $border-radius-sm;
    overflow: hidden;

    .el-table__header {
      background: var(--gradient-header);

      th {
        font-weight: 600;
        color: var(--text-primary);
        background: transparent;
      }
    }

    .image-preview-cell {
      display: flex;
      justify-content: center;
      align-items: center;

      .thumbnail-image {
        width: 60px;
        height: 60px;
        border-radius: $border-radius-sm;
        cursor: pointer;
        transition: $transition-base;
        border: 1px solid $border-light;

        &:hover {
          transform: scale(1.05);
          box-shadow: var(--shadow-base);
        }
      }

      .image-error {
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: $bg-base;
        border-radius: $border-radius-sm;
        color: $text-placeholder;
      }
    }

    .no-image {
      color: $text-placeholder;
      font-size: $font-size-sm;
    }
  }
}

.bg-pagination {
  margin-top: $spacing-lg;
  text-align: center;
}

// 预览对话框样式
.preview-dialog {
  .preview-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
    background: $bg-base;
    border-radius: $border-radius-base;
    padding: $spacing-lg;

    .preview-image {
      max-width: 100%;
      max-height: 400px;
      border-radius: $border-radius-sm;
    }

    .preview-error {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: $text-placeholder;

      i {
        font-size: 48px;
        margin-bottom: $spacing-md;
      }
    }
  }

  .preview-info {
    margin-top: $spacing-lg;
    padding: $spacing-md;
    background: $bg-base;
    border-radius: $border-radius-sm;

    p {
      margin: $spacing-sm 0;
      color: var(--text-regular);

      strong {
        color: var(--text-primary);
        display: inline-block;
        width: 60px;
      }
    }
  }
}

// 响应式适配
@media (max-width: $screen-md) {
  .bg-toolbar {
    flex-direction: column;
    gap: $spacing-md;
    align-items: flex-start;
  }
}

@media (max-width: $screen-sm) {
  .bg-page-header {
    flex-direction: column;
    gap: $spacing-md;
    align-items: flex-start;
  }

  .preview-dialog {
    .preview-container {
      min-height: 200px;
      padding: $spacing-md;

      .preview-image {
        max-height: 250px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bg/SchoolReview.vue